<template>
  <transition name="slide">   
      <div>
        <b-card no-body>
          <b-card-header>
                {{ modalTitle }}
                <div class="pull-right">
                  <file-input multiple accept='image/*,video/*' :uploader="uploader">
                    <span title="Choose Files" v-b-tooltip.hover class="icon ion-upload btn btn-success btn-sm">Choose Files</span>
                  </file-input>
                </div>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col>
                Vin Number: <strong v-html="modalform.vehvin"></strong>
              </b-col>
              <b-col>
                Receipt Date : <strong>{{ modalform.vehreceiptdate | dateFormat }}</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col> Mfr : <strong v-html="modalform.vehmfr"></strong></b-col>
              <b-col> Mfr Date: <strong v-if="modalform.vehmfrdate !=''">{{ modalform.vehmfrdate | dateFormat }}</strong></b-col>
            </b-row>
            <b-row>  
              <b-col> Make : <strong v-html="modalform.vehyear"></strong></b-col>
              <b-col> Model: <strong v-html="modalform.vehmodel"></strong></b-col>
            </b-row>
          </b-card-body>   
      </b-card>  
      <b-card no-body>
        <b-card-header>
              Inventory Images 
        </b-card-header>
        <b-card-body>
            <b-table responsive show-empty id="imagetable" :busy.sync="isBusy" :filter="filter" :items="myProvider" :fields="fields" :current-page="currentPage" :per-page="perPage">
                <template v-slot:cell(vimthumbpreview)="data">
                  <img class="curpointer" @click="openImgPreview(data.item.vimdindex)" :src="data.item.vimthumbpreview" :data-index="data.item.vimdindex" width="100" height="100" v-if="data.item.vimthumbpreview != ''"/>
                  <video class="curpointer" @click="openImgPreview(data.item.vimdindex)" width="100" height="100" v-else>
                    <source :src="data.item.vimpreview" type="video/mp4">
                    <source :src="data.item.vimpreview" type="video/Ogg">
                  </video>
                </template>
                 <template v-slot:cell(vimname)="data">
                  {{ data.item.vimname }}
                </template>
                 <template v-slot:cell(vimsize)="data">
                  {{ data.item.vimsize }}
                </template>
                <template v-slot:cell(createddate)="data">
                  {{ data.item.createddate | dateTimeFormat }}
                </template>
                <template v-slot:cell(vimisdefault)="data">
                    <i v-if="data.item.vimisdefault" class="fa fa-check-circle marked" v-b-tooltip.hover  title="Marked As Default Image"></i>
                    <i v-else class="fa fa-times-circle unmarked curpointer" @click.stop="addMaskDefault(data.item.vimindex)" v-b-tooltip.hover  title="Set Mark As Default Image"></i>
                </template>
                
                <template v-slot:cell(action)="data">
                  <b-button-group>                      
                     <b-button title="Delete" size="sm" v-b-tooltip.hover variant="danger" @click.stop="del(data.item.vimindex)"><span> <i class="fa fa-remove" ></i> Delete</span></b-button>
                  </b-button-group>    
                </template>
              </b-table>
              <nav v-if="totalRows>0">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
      </b-card-body>
    </b-card>
      <!-- <LightBox 
        :images="vehicleimages" 
        ref="lightbox"
        :show-caption="true"
        :show-light-box="false"
      ></LightBox> -->
      <CoolLightBox 
        :items="vehicleimages" 
        :index="imgIndex"
        loop
        @close="imgIndex = null">
      </CoolLightBox>
  </div> 
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex' 
import { getResponseMessages, getUserInfo, getUserToken } from '../../_helpers'
import FineUploaderTraditional from 'fine-uploader-wrappers'
// import Gallery from 'vue-fineuploader/gallery'
import FileInput from 'vue-fineuploader/file-input'
import LightBox from 'vue-image-lightbox'
import CoolLightBox from 'vue-cool-lightbox'
export default {
  name: 'Inventory_View',
  components: {
    FileInput,
    LightBox,
    CoolLightBox
  },
  data: () => {
    return { 
      latitude:null,
      longitude:null,
      uploader:{},
      vehicleimages:[],
      options : {
        closeText : 'X'
      },
      modalform:{},
      modalTitle:'',
      itemsData: [],
      fields: [
        {key: 'vimthumbpreview',sortable:false,label: 'Image Preview'},
        {key: 'vimname',sortable:true,label: 'Image Name'},
        {key: 'vimsize',sortable:true, label: 'Image Size'},
        {key: 'vimisdefault',sortable:true, label: 'Is Default'},
        {key: 'createddate',sortable:true, label: 'Uploaded Date'},
        {key: 'action',label: 'Action'}
      ],
      isBusy: false,
      lastPerPage: 5,
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      pageOptions: [ 5, 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      imgIndex: null
    }
  },
  computed: {
    ...mapGetters(["getRecordTotal", "getRecords"])
  },
  beforeCreate() {
    navigator.geolocation.getCurrentPosition(pos => {
      this.longitude = pos.coords.longitude;
      this.latitude = pos.coords.latitude;
    }, err => {
    });
  },
  created(){
    this.locateMe();
    if(this.$route.params.id != undefined){
      this.loadInvData(this.$route.params.id)
      this.loadUploader(this.$route.params.id);
    } 
  },       
  methods: {
    ...mapActions('org', ['getById','getList','delById']),
    myProvider(ctx){
      this.isBusy = true
      if(this.lastPerPage != ctx.perPage){
        this.lastPerPage = ctx.perPage;
        ctx.currentPage = 1;
      }
      var startVal = (ctx.currentPage-1) * ctx.perPage
      ctx['start'] = startVal
      ctx['length'] = ctx.perPage
      ctx['vehIndex'] = this.$route.params.id
      this.itemsData = [];
      this.vehicleimages = [];
      let promise = this.$store.dispatch('getList',{ url:'vehicles/getImagesList',data: ctx })
      let itemsx = []
      return promise.then((res) => {
          itemsx = this.$store.state.org.records
          this.totalRows = this.$store.state.org.recordTotal
          itemsx.forEach((xt) => {
            this.vehicleimages.push({  'thumb': xt.vimthumbpreview,'src': xt.vimpreview,'title':xt.vimname });
          });
          return(itemsx)
      })
      return(itemsx)
    },
    openImgPreview(index) {
      this.imgIndex = index;
    },
    loadInvData(vehindex) {
      
      this.$store.dispatch('getById', {url:'vehicles/getVehicleById',data : { 'vehIndex':vehindex }}).then((res) => {
        this.modalform = Object.assign({}, res.details)
        this.modalTitle = 'Detail :- '+ res.details.vehvin
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    },
    loadUploader(vehIndex) {

        setTimeout(()=>{
          const imgUploadURL = this.$API_URL;
          const uToken = "Basic "+getUserToken();
          const swal = this.$swal;
          var cordsLatitude = null;
          var cordsLongitude = null;
          navigator.geolocation.getCurrentPosition(pos => {
            cordsLongitude = pos.coords.longitude;
            cordsLatitude = pos.coords.latitude;
          }, err => {
          });
          cordsLatitude = this.latitude;
          cordsLongitude = this.longitude;
          const uploadObj =  new FineUploaderTraditional({
            options: {  
              callbacks: {
                onValidateBatch: function(fileOrBlobDataArray,buttonContainer) {
                  if(fileOrBlobDataArray.length > uploadObj.options.validation.itemLimit){
                    swal('Cancelled','You are attempting to upload more then '+uploadObj.options.validation.itemLimit+' files at once. Try reducing the number of files.','error')
                    return false
                  }else{
                    swal({
                      title: 'Please wait',
                      text: 'uploading files.....',
                      showConfirmButton: false,
                      allowOutsideClick: false
                    })
                  }
                  return true
                },
                onValidate: function(fileOrBlobData) {
                  var fileExt = fileOrBlobData.name.split('.').pop();
                  var fileExtList = uploadObj.options.validation.allowedExtensions;
                  var foldeResult = fileExtList.filter(function(cust){
                    return cust.toLowerCase().indexOf( fileExt.toLowerCase()) >=0 ;
                  });
                  if(foldeResult.length == 0){
                    swal('Cancelled','You have uploaded an invalid image/Video file type. you can only upload following files type:- jpg,jpeg,png,mp4,avi','error');
                    return false
                  }
                  /*if(fileOrBlobData.size > uploadObj.options.validation.sizeLimit){
                    swal('Cancelled','You have uploaded image/Video size of more then 50Mb.','error');
                    return false
                  }*/
                  return true
                }  
              }, 
              validation: {
                stopOnFirstInvalidFile: false,
                allowedExtensions: ['jpg','jpeg','png','mp4','avi'],
                itemLimit: 5
                // sizeLimit:50000000
              },
              chunking: {
                enabled: true,
                concurrent: {
                  enabled: true
                },
                partSize:4000000,
                mandatory: true
              },
              resume: {
                enabled: true
              },
              request: {
                endpoint: imgUploadURL+'vehicles/uploadimage', 
                params:{
                  'vehIndex':vehIndex,
                  'latitude':cordsLatitude,
                  'longitude':cordsLongitude
                },
                customHeaders: {
                  "Authorization": uToken
                },
                requireSuccessJson:false
              }
            }
          })
          uploadObj.on('onAllComplete', (response,aa) => {
            swal.clickCancel();
            this.$root.$emit('bv::refresh::table', 'imagetable');
          })
          this.uploader = uploadObj
        },50);
    },  
    addMaskDefault(itemid) {
        this.$swal({
            title: 'Are you sure?',
            text: 'You want to mask as default this image!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, mark it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
                let vehId = this.$route.params.id;
                this.$store.dispatch('delById', {url:'vehicles/setVehicleDefaultImage',data : { 'vimIndex':itemid, 'vehIndex':vehId }}).then((res) => {
                  this.$root.$emit('bv::refresh::table', 'imagetable');
                  this.$swal('Updated!',getResponseMessages(res.data.messages),'success')
                },(error) =>{
                  this.$swal('Cancelled',getResponseMessages(error.data.messages),'error')
                });
            }
          })
    },
    async getLocation() {  
      return new Promise((resolve, reject) => {

        if(!("geolocation" in navigator)) {
          reject(new Error('Geolocation is not available.'));
        }

        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos);
        }, err => {
          reject(err);
        });

      });
    },
    async locateMe() {
      try {
        let location = await this.getLocation();
        this.latitude = location.coords.latitude;
        this.longitude = location.coords.longitude;
      } catch(e) {
        this.$toastr('error', getResponseMessages(e.message), 'Error')
      }
    },
    del(itemid) {
        this.$swal({
            title: 'Are you sure?',
            text: 'You want to remove this image!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
                let vehId = this.$route.params.id;
                this.$store.dispatch('delById', {url:'vehicles/removeVehiclesImage',data : { 'vimIndex':itemid, 'vehIndex':vehId  }}).then((res) => {
                  this.$root.$emit('bv::refresh::table', 'imagetable');
                  this.$swal('Deleted!',getResponseMessages(res.data.messages),'success')
                },(error) =>{
                  this.$swal('Cancelled',getResponseMessages(error.data.messages),'error')
                });
            }
          })
    }
  }
}
</script>
<style type="text/css">
.vue-fine-uploader-file-input label {
   margin-bottom: 0px;
} 
.unmarked{
  color:#f86c6b;
}
.marked{
  color:#3a9d5d;
}
.curpointer{
  cursor: pointer;
}    
</style>
